import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ProjectionTrackingScreen, WorkflowScreen } from 'modules/core/components'
import PlanningDetail from './PlanningDetail/PlanningDetail'
import PlanningHome from './PlanningHome/PlanningHome'
import GlobalBudgetDetailHome from './GlobalBudgetDetailHome/GlobalBudgetDetailHome'
import MonitorWorkflow from './Workflow'

const Home = () => (
  <Switch>
    <Route exact path="/planificacion/:periodId" component={PlanningHome} />
    <Route exact path="/planificacion/:periodId/workflow" component={WorkflowScreen} />
    <Route exact path="/planificacion/:periodId/actividad" component={ProjectionTrackingScreen} />
    <Route
      exact
      path="/planificacion/:periodId/:conceptName/:step/workflow/:projectionId"
      component={MonitorWorkflow}
    />
    <Route exact path="/planificacion/:periodId/:conceptName" component={PlanningHome} />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId"
      component={GlobalBudgetDetailHome}
    />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId/:type"
      component={GlobalBudgetDetailHome}
    />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId/:type/:currency"
      component={GlobalBudgetDetailHome}
    />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId/:type/:currency/:reportId"
      component={GlobalBudgetDetailHome}
    />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId/:type/:currency/:reportId/:tableType"
      component={GlobalBudgetDetailHome}
    />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId/:type/:currency/:reportId/:tableType/:base"
      component={GlobalBudgetDetailHome}
    />
    <Route
      exact
      path="/planificacion/:periodId/:conceptName/:budgetId"
      component={PlanningDetail}
    />
    <Route
      exact
      path="/planificacion/:periodId/:conceptName/:budgetId/:step"
      component={PlanningDetail}
    />
    <Route
      exact
      path="/planificacion/:periodId/:conceptName/:budgetId/:step/:tab"
      component={PlanningDetail}
    />
    <Route
      exact
      path="/planificacion/:periodId/:conceptName/:projectionId/:step/:tab/actividad/"
      component={ProjectionTrackingScreen}
    />
    <Route
      exact
      path="/planificacion/:periodId/presupuestoglobal/:globalBudgetId/:type/:currency/:reportId/:tableType/:base/actividad"
      component={ProjectionTrackingScreen}
    />
    <Redirect to="/planificacion" />
  </Switch>
)

export default Home
